import React, { useMemo, useState } from "react";
import { QueryDynamicOptionsInput } from "components/queries/queryBuilder/dialogParts/QueryDynamicKeywordInput";
import { QueryFixedKeywordInput } from "components/queries/queryBuilder/dialogParts/QueryFixedKeywordInput";
import { KeywordInputType, QueryField, QueryInfo, fieldIsKeyword, getKeywordInputType } from "system/query/QueryInfo";
import { TextField } from "@mui/material";

export interface KeywordOptionSelectorProps {
  queryInfo: QueryInfo;
  selectedField: QueryField | undefined;
  selectedKeywordOption: string | undefined;
  selectedKeywordLabel?: string;
  setSelectedKeywordOption: (newKeywordOption: string | undefined, newKeywordOptionLabel?: string | undefined) => void;
  enforceFixedSelection?: boolean;
  excludeOptions?: string[];
}

export default function KeywordOptionSelector(props: KeywordOptionSelectorProps): JSX.Element {
  const { queryInfo, selectedField, selectedKeywordOption, setSelectedKeywordOption } = props;

  const [autocompleteLabel, setAutocompleteLabel] = useState<string>(props.selectedKeywordLabel || "");

  const keywordInputType = useMemo(() => {
    if (props.selectedField && fieldIsKeyword(props.selectedField)) {
      return getKeywordInputType(props.selectedField);
    }
  }, [props.selectedField]);

  return (
    <>
    {(keywordInputType === KeywordInputType.string) &&
      <TextField
        autoComplete="off"
        variant="outlined"
        value={selectedKeywordOption || ""}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setSelectedKeywordOption(event.target.value || undefined);
        }}
      />
    }
    {(keywordInputType !== KeywordInputType.string && selectedField?.options) &&
      <QueryFixedKeywordInput
        queryInfo={queryInfo}
        selectedField={selectedField}
        value={selectedKeywordOption}
        enforceSelection={props.enforceFixedSelection}
        excludeOptions={props.excludeOptions}
        setValue={(newValue: string | number | boolean | null | undefined, newLabel?: string | undefined) => {
          setSelectedKeywordOption(newValue ? newValue as string : undefined, newLabel);
        }}
      />
    }
    {(selectedField && fieldIsKeyword(selectedField) && !selectedField.options && keywordInputType !== KeywordInputType.string) &&
      <QueryDynamicOptionsInput
        queryInfo={queryInfo}
        selectedField={selectedField}
        label={autocompleteLabel}
        setLabel={setAutocompleteLabel}
        value={selectedKeywordOption}
        excludeOptions={props.excludeOptions}
        setValue={(newValue: string | number | boolean | null | undefined, newLabel?: string | undefined) => {
          setSelectedKeywordOption(newValue ? newValue as string : undefined, newLabel);
        }}
      />
    }
    </>
  );
}